import { create } from 'zustand';

type InsuranceStore = {
  primaryOtherHasOverlap: boolean;
  secondaryHasOverlap: boolean;
  setPrimaryOtherHasOverlap: (value: boolean) => void;
  setSecondaryHasOverlap: (value: boolean) => void;
};

export const useInsuranceStore = create<InsuranceStore>(set => ({
  primaryOtherHasOverlap: false,
  secondaryHasOverlap: false,
  setPrimaryOtherHasOverlap: value => set({ primaryOtherHasOverlap: value }),
  setSecondaryHasOverlap: value => set({ secondaryHasOverlap: value }),
}));
